import { t } from '@lingui/macro';
import { useApi } from '@prismo-io/core';
import type { SWRArgs } from '@prismo-io/schemas';
import toast from 'react-hot-toast';
import useSWRMutation from 'swr/mutation';
import { type ParamsSchemaT, sendExperience } from '../utils/send-experience';

export function useSendExperience() {
  const { client } = useApi();

  return useSWRMutation(
    'send-quark-experience',
    (key, { arg }: SWRArgs<ParamsSchemaT>) => {
      const name = arg.customName ?? arg.designation.name;

      return toast.promise(sendExperience(client, arg), {
        loading: arg.id
          ? t`Mise à jour de l'expérience ${name}.`
          : t`Création de l'expérience ${name}.`,
        success: arg.id
          ? t`L'expérience ${name} a bien été mise à jour.`
          : t`L'expérience ${name} a bien été créée.`,
        error: arg.id
          ? t`Une erreur est survenue lors de la mise à jour de l'expérience.`
          : t`Une erreur est survenue lors de la création de l'expérience.`,
      });
    }
  );
}
